import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '@lmc-app/core/services/notification.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';

export interface EnvironmentInfoData {
	version: string;
	environment: string;
	notificationPermission: string;
	fcmToken: string;
}

@Component({
	selector: 'app-environment-info-dialog',
	templateUrl: './environment-info-dialog.component.html',
	styleUrls: ['./environment-info-dialog.component.scss']
})
export class EnvironmentInfoDialogComponent implements OnDestroy {
	isSendingTest = false;
	private readonly destroy$ = new Subject<void>();

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: EnvironmentInfoData,
		private readonly notificationService: NotificationService,
		private readonly snackBar: MatSnackBar
	) {}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	async sendTestNotification(): Promise<void> {
		if (this.data.notificationPermission !== 'granted') {
			this.snackBar.open(
				'Notification permission not granted. Please allow notifications first.',
				'Close',
				{ duration: 5000 }
			);
			return;
		}

		if (!this.data.fcmToken || this.data.fcmToken === 'N/A' || this.data.fcmToken === 'Permission not granted') {
			this.snackBar.open(
				'No valid FCM token available.',
				'Close',
				{ duration: 5000 }
			);
			return;
		}

		this.isSendingTest = true;

		this.notificationService
			.sendTestNotification(
				this.data.fcmToken,
				'Test Notification',
				'This is a test notification from LMCredit External.'
			)
			.subscribe({
				next: (response) => {
					console.log('Test notification sent successfully:', response);
					this.snackBar.open(
						'Test notification sent successfully! Check your notifications.',
						'Close',
						{ duration: 5000 }
					);
					this.isSendingTest = false;
				},
				error: (error) => {
					console.error('Failed to send test notification:', error);
					this.snackBar.open(
						error.error?.message || 'Failed to send test notification.',
						'Close',
						{ duration: 5000 }
					);
					this.isSendingTest = false;
				},
			});
	}
}